/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  FwenMultiStaker,
  FwenMultiStakerInterface,
} from "../../../../contracts/fwen/FwenMultiStaker.sol/FwenMultiStaker";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_admin",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ArrayLengthMismatch",
    type: "error",
  },
  {
    inputs: [],
    name: "CutExceed",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidGuest",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidOrderId",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidRegisterTime",
    type: "error",
  },
  {
    inputs: [],
    name: "NonAdmin",
    type: "error",
  },
  {
    inputs: [],
    name: "NonHost",
    type: "error",
  },
  {
    inputs: [],
    name: "NonHostOrGuest",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "RegisterEnded",
    type: "error",
  },
  {
    inputs: [],
    name: "RegisterNotStart",
    type: "error",
  },
  {
    inputs: [],
    name: "RegisterStarted",
    type: "error",
  },
  {
    inputs: [],
    name: "StakingStarted",
    type: "error",
  },
  {
    inputs: [],
    name: "StakingUncancelable",
    type: "error",
  },
  {
    inputs: [],
    name: "TokenAlreadyStaked",
    type: "error",
  },
  {
    inputs: [],
    name: "WithdrawFailed",
    type: "error",
  },
  {
    inputs: [],
    name: "WrongContractToken",
    type: "error",
  },
  {
    inputs: [],
    name: "WrongTokenNumber",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "OfferUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "nft",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "StakedToken",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "enum FwenMultiStaker.StakingStatus",
        name: "status",
        type: "uint8",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
    ],
    name: "StakingStatusChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "TransferOfferFailed",
    type: "event",
  },
  {
    inputs: [],
    name: "admin",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "programId",
        type: "uint128",
      },
      {
        internalType: "uint256",
        name: "registerStartTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "registerEndTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "rewardAction",
        type: "uint8",
      },
      {
        internalType: "address[]",
        name: "tokenContracts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "tokenNumbers",
        type: "uint256[]",
      },
      {
        internalType: "address[]",
        name: "rewardContracts",
        type: "address[]",
      },
      {
        internalType: "bool",
        name: "cancelable",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "cut",
        type: "uint256",
      },
    ],
    name: "configStakingProgram",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
    ],
    name: "endStaking",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "orderIds",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "violateRoles",
        type: "uint256[]",
      },
    ],
    name: "handleViolates",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
      {
        internalType: "uint128",
        name: "programId",
        type: "uint128",
      },
    ],
    name: "ifStakingEnded",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "tokenContracts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "tokenNums",
        type: "uint256[]",
      },
    ],
    name: "joinStaking",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "programId",
        type: "uint128",
      },
      {
        internalType: "address[]",
        name: "tokenContracts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "tokenNums",
        type: "uint256[]",
      },
      {
        internalType: "address",
        name: "guest",
        type: "address",
      },
    ],
    name: "requestStaking",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "nft",
        type: "address",
      },
      {
        internalType: "bool",
        name: "ifGuest",
        type: "bool",
      },
    ],
    name: "stakedTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "stakingOrders",
    outputs: [
      {
        internalType: "address",
        name: "host",
        type: "address",
      },
      {
        internalType: "address",
        name: "guest",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "offer",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "startTime",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128",
      },
    ],
    name: "stakingPrograms",
    outputs: [
      {
        internalType: "uint256",
        name: "registerStartTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "registerEndTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256",
      },
      {
        internalType: "enum FwenMultiStaker.RewardAction",
        name: "rewardAction",
        type: "uint8",
      },
      {
        internalType: "uint128",
        name: "counter",
        type: "uint128",
      },
      {
        internalType: "bool",
        name: "cancelable",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "cut",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "updateAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
    ],
    name: "updateOffer",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type FwenMultiStakerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: FwenMultiStakerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class FwenMultiStaker__factory extends ContractFactory {
  constructor(...args: FwenMultiStakerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _admin: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<FwenMultiStaker> {
    return super.deploy(_admin, overrides || {}) as Promise<FwenMultiStaker>;
  }
  override getDeployTransaction(
    _admin: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_admin, overrides || {});
  }
  override attach(address: string): FwenMultiStaker {
    return super.attach(address) as FwenMultiStaker;
  }
  override connect(signer: Signer): FwenMultiStaker__factory {
    return super.connect(signer) as FwenMultiStaker__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): FwenMultiStakerInterface {
    return new utils.Interface(_abi) as FwenMultiStakerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): FwenMultiStaker {
    return new Contract(address, _abi, signerOrProvider) as FwenMultiStaker;
  }
}
